import template from "../../home-safety-solution.module.scss";
import Image from "next/image";
import animations from "@styles/animations.module.scss";
import { InView } from "react-intersection-observer";
import style from "./technologies-section.module.scss";
import { useEffect, useState } from "react";
import { WindowSizeBreakpointsEnum } from "@helpers/window-size-breakpoints";

interface TechnologiesProps {
  title: string;
  images: {
    desktop: string;
    tablet: string;
    mobile: string;
  };
}

const TechnologiesSection = ({ title, images }: TechnologiesProps) => {
  const [imageSrc, setImageSrc] = useState(images.desktop);

  useEffect(() => {
    function updateState() {
      const width = document.body.offsetWidth;

      if (width <= WindowSizeBreakpointsEnum.Mobile) {
        setImageSrc(images.mobile);
      } else if (width <= WindowSizeBreakpointsEnum.Tablet) {
        setImageSrc(images.tablet);
      } else {
        setImageSrc(images.desktop);
      }
    }

    updateState();

    window.addEventListener("resize", updateState);
    return () => window.removeEventListener("resize", updateState);
  }, [images]);
  return (
    <section className={`${template.section}`}>
      <div className={`${template.container}`}>
        <InView triggerOnce={true}>
          {({ inView, ref, entry }: any) => {
            if (inView) {
              entry.target.classList.add(animations.active);
            }
            return (
              <div
                ref={ref}
                className={`${animations.scroll__animation} ${template.title} ${template.title_medium} ${template.margin_bot60px} ${template.text_align_center}`}
              >
                {title}
              </div>
            );
          }}
        </InView>
        <InView triggerOnce={true}>
          {({ inView, ref, entry }: any) => {
            if (inView) {
              entry.target.classList.add(animations.active);
            }
            return (
              <div
                ref={ref}
                className={`${animations.scroll__animation} ${style.technologies__image}`}
              >
                <Image src={imageSrc} alt={title} layout={"fill"} />
              </div>
            );
          }}
        </InView>
      </div>
    </section>
  );
};

export default TechnologiesSection;
